var map = {
	"./apple-icon.png": 87658,
	"./background.jpg": 22152,
	"./canon.svg": 79771,
	"./faces/face-0.jpg": 82117,
	"./faces/face-1.jpg": 19752,
	"./faces/face-2.jpg": 53975,
	"./faces/face-3.jpg": 59514,
	"./favicon.png": 90286,
	"./glyphicons-halflings-regular.8988968.svg": 14882,
	"./layout.jpg": 22298,
	"./new_logo.png": 76132,
	"./rating-star-full.svg": 42268,
	"./rating-star-half.svg": 81124,
	"./rating-star-void.svg": 6957,
	"./tim_80x80.png": 75633,
	"./vue-logo.png": 33732
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;